import { Box, IconButton, Tooltip } from "@mui/material";
import { styles } from "../TracksPageComponents/styles";
import { Link as MuiLink } from "@mui/material";
import { THEME } from "../../theme";
import YouTubeIcon from "@mui/icons-material/YouTube";

export const DrawerSocialMediaLinks: React.FC = () => {
  return (
    <>
      <Box sx={styles.socialMediaLinksContainer}>
        <a
          target="_blank"
          href="https://www.facebook.com/ommuse.music"
          rel="noreferrer"
        >
          <Tooltip title="Facebook">
            <IconButton sx={styles.iconButton}>
              <Box sx={styles.socialButtonContainer}>
                <img
                  style={{ width: "24px", height: "24px" }}
                  src="/assets/icons/TracksPageIcons/Social icon.svg"
                  alt="icon"
                />
              </Box>
            </IconButton>
          </Tooltip>
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/ommuse.music/"
          rel="noreferrer"
        >
          <Tooltip title="Instagram">
            <IconButton sx={styles.iconButton}>
              <Box sx={styles.socialButtonContainer}>
                <img
                  style={{ width: "24px", height: "24px" }}
                  src="/assets/icons/TracksPageIcons/Group.svg"
                  alt="icon"
                />
              </Box>
            </IconButton>
          </Tooltip>
        </a>
        <a target="_blank" href="https://youtube.com/@ommuse/" rel="noreferrer">
          <Tooltip title="Youtube">
            <IconButton sx={styles.iconButton}>
              <Box
                sx={{
                  ...styles.socialButtonContainer,
                  ...{ paddingTop: "4px", paddingBottom: "4px" },
                }}
              >
                <YouTubeIcon sx={{ height: "20px" }} />
              </Box>
            </IconButton>
          </Tooltip>
        </a>
        <Tooltip title="Support">
          <MuiLink href="mailto:hello@ommuse.com">
            <IconButton sx={styles.iconButton}>
              <Box sx={styles.socialButtonContainer}>
                <img
                  style={{
                    filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
                  }}
                  src="/assets/icons/TracksPageIcons/life-buoy-01.svg"
                  alt="icon"
                />
              </Box>
            </IconButton>
          </MuiLink>
        </Tooltip>
      </Box>
    </>
  );
};
